import React from "react";
import wholeTableMark from "../assets/brand/whole-table.png";
import "../design/tokens.css";
import "./PublicAppHeader.css";

export function PublicBrand({ href = "https://vibesplit.xyz", newTab = false }: { href?: string; newTab?: boolean }) {
  return (
    <a className="public-brand" href={href} target={newTab ? "_blank" : undefined} rel={newTab ? "noopener noreferrer" : undefined} aria-label="Open Vibesplit">
      <img className="public-brand__mark" src={wholeTableMark} width={32} height={32} alt="" aria-hidden="true" />
      <span className="public-brand__name">vibesplit</span>
    </a>
  );
}

export default function PublicAppHeader({ showAppLink = true }: { showAppLink?: boolean }) {
  return (
    <div className="vs-design public-app-header mb-4 px-0 pt-[4px] pb-1 text-left">
      <PublicBrand newTab />
      {showAppLink && <a href={/^\/(b|t)\/[^/]+\/?$/.test(window.location.pathname) ? `/app/open${window.location.pathname}` : '/app/'} className="vs-button vs-button--secondary" style={{ marginLeft: 'auto' }}>Use web app</a>}
    </div>
  );
}
